<template>
  <div class="inner_box">
    <div class="left_box">
      <!--      {{ spaceSize }}-->
      <!--      {{targetTabData}}-->
      <!--      {{isEnterpriseMainUser.value}}-->
      <div><span :class="['line_title', langClass]">{{ $t('common.cloud.file.space.total') }}</span>
        <!--        v-if="isEnterpriseChildUser"-->
        <span class="txt">{{ spaceSizeFormat(displaySpaceData.effectiveLocation) }}</span>
        <!-- <el-button v-if="(isEnterpriseMainUser && route.query.searchType) || isNormalUser" style="margin-left:6px;" type="primary" link @click="showStationDetails">查看明细</el-button> -->
      </div>
      <div>
        <span :class="['line_title', langClass]">{{ $t('common.space.use') }}</span>
        <span class="txt">{{ spaceSizeFormat(displaySpaceData.fileCloudLocation) }}</span>
      </div>
      <div><span :class="['line_title', langClass]">{{ $t('common_cloud_file_space_available') }}</span>
        <span class="txt">{{ spaceSizeFormat(displaySpaceData.freeLocation) }}</span>
      </div>
    </div>
    <div class="right_box">
      <div ref="chartRef" :style="{ width: '450px', height: '350px' }"></div>
      <!-- 调试信息 -->
      <!-- <div style="margin-top: 10px; font-size: 12px; color: #666;">
        <div>searchType: {{ route.query.searchType }}</div>
        <div>computedTargetInit length: {{ computedTargetInit?.length }}</div>
        <div>targetTabData exists: {{ !!targetTabData?.mailStorageVo }}</div>
        <div>Chart instance: {{ !!myChartTargetDom }}</div>
      </div> -->
    </div>

    <!-- 存储空间明细对话框 -->
    <el-dialog
        v-model="dialogVisibleDetails"
        title="存储空间 明细"
        width="800px"
        :close-on-click-modal="false"
    >
      <div class="storage-details">
        <el-table 
            :data="targetTabData?.mailContainDataVoList" 
            style="width: 100%"
            :header-cell-style="{background: '#f9f9f9', color: 'black', padding: '8px 0px'}"
        >
          <el-table-column prop="containData" label="存储容量" width="150">
            <template #default="{row}">
              {{ spaceSizeFormat(row.containData ?? 0) }}
            </template>
          </el-table-column>
          <el-table-column prop="productSort" label="类型" width="150">
            <template #default="{row}">
              <span v-if="row.free">{{ $t('common.mf') }}</span>
              <span v-else>{{ $t(productSortSwitch(row.productSort * 1)) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="startTime" label="开始时间" width="180">
            <template #default="{row}">
              <span v-if="row.startTime">{{ toISODateTime(row.startTime) }}</span>
              <span v-else>{{ $t('common.yjmf') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="endTime" label="结束时间" width="180">
            <template #default="{row}">
              <span v-if="row.endTime">{{ toISODateTime(row.endTime) }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="100">
            <template #default="{row}">
              <el-tag v-if="row.free" type="success">免费</el-tag>
              <el-tag v-else type="primary">付费</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button size="small" @click="dialogVisibleDetails = false">关闭</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import {echarts, formatEchartsData} from "@/utils/echarts";
import {i18n} from "@/lang";
import {computed, nextTick, onMounted, onUnmounted, ref, watch} from "vue";
import {ElMessage} from "element-plus";
import {spaceSizeFormat} from "@/utils/file";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import {productSortSwitch} from "@/utils/util";
import {toISODateTime} from "@/views/Home/utils";

const route = useRoute()
const store = useStore();
// 初始化 环形图
const chartRef = ref(null)
const myChartTargetDom = ref(null)
// 存储空间明细对话框
const dialogVisibleDetails = ref(false)

const isEnterpriseMainUser = computed(() => store.getters['user/isEnterpriseMainUser'])
const isEnterpriseChildUser = computed(() => store.getters['user/isEnterpriseChildUser'])
const isNormalUser = computed(() => store.getters["user/isNormalUser"])
const userDataInformation = computed(() => store.state.cloud.userDataInformation)
const targetTabData = computed(() => store.state.cloud.targetTabData)
const lang = computed(() => store.state.system.langLocal)

const toSafeNumber = (value) => {
  const numberValue = Number(value)
  return Number.isFinite(numberValue) ? numberValue : 0
}

const formatPercentageDisplay = (value) => {
  const percentageValue = toSafeNumber(value)

  if (percentageValue <= 0) {
    return '0%'
  }

  if (percentageValue < 0.01) {
    return '<0.01%'
  }

  return `${percentageValue.toFixed(2).replace(/\.?0+$/, '')}%`
}

const normalizeStorageData = (source = {}) => {
  const total = Math.max(toSafeNumber(source?.effectiveLocation), 0)
  const free = Math.max(toSafeNumber(source?.freeLocation), 0)
  const rawUsed = Math.max(
    toSafeNumber(source?.fileCloudLocation),
    toSafeNumber(source?.useLocation),
    0
  )
  const calculatedUsed = total > 0 ? Math.max(total - free, 0) : rawUsed
  const used = calculatedUsed > 0 || rawUsed === 0 ? calculatedUsed : rawUsed

  return {
    ...source,
    effectiveLocation: total,
    freeLocation: Math.min(free, total || free),
    fileCloudLocation: used,
    useLocation: used
  }
}

const isSearchMode = computed(() => Boolean(route.query.searchType))

const displaySpaceData = computed(() => {
  if (isSearchMode.value) {
    return normalizeStorageData(targetTabData.value?.mailStorageVo ?? targetTabData.value)
  }
  return normalizeStorageData(spaceSize.value)
})

const chartData = computed(() => {
  return formatEchartsData(displaySpaceData.value).map((item) => {
    const percentageValue = Number(item.percentage)
    const validPercentage = Number.isFinite(percentageValue) ? percentageValue : 0

    return {
      ...item,
      name: i18n.global.t(item.name),
      num: toSafeNumber(item.num),
      numStr: item.numStr || spaceSizeFormat(item.num ?? 0),
      value: toSafeNumber(item.num),
      percentage: validPercentage,
      percentageText: formatPercentageDisplay(validPercentage)
    }
  })
})

const isSyncingChartData = ref(false)

const getChartInstance = () => {
  if (!chartRef.value) {
    return null
  }

  if (myChartTargetDom.value) {
    return myChartTargetDom.value
  }

  myChartTargetDom.value = echarts.getInstanceByDom(chartRef.value) || echarts.init(chartRef.value)
  return myChartTargetDom.value
}

const renderEcharts = () => {
  const myChart = getChartInstance()

  if (!myChart) {
    return
  }

  if (!chartData.value.length) {
    myChart.clear()
    return
  }

  const option = {
    tooltip: {
      trigger: 'item',
      formatter: function (params) {
        return `<span>
                    ${params.data.name + ": " + params.data.numStr}
                </span>
                <br/>
                <span>
                  ${i18n.global.t('echarts.space.text')}: ${params.data.percentageText}
                </span>`
      }
    },
    legend: {
      bottom: '2%',
      left: 'center',
      icon: "square",
      formatter: (valueName) => {
        const matchedItem = chartData.value.find(item => item.name === valueName);
        const actualValue = matchedItem?.numStr ?? spaceSizeFormat(0);
        const percentageText = matchedItem?.percentageText ?? '0%';
        return `${valueName} ${actualValue} (${percentageText})`;
      },
    },
    color: ["#678ef2", "#7dd5a9", "#616f8f"],
    series: [
      {
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center',
          formatter: function (params) {
            return (
                '{a|' +
                params.name +
                '}' +
                '\n\n' +
                '{b|' +
                params.data.numStr +
                '}' +
                '\n' +
                '{c|' +
                params.data.percentageText +
                '}'
            );
          },
          rich: {
            a: {
              color: '#8c8c8c',
              fontSize: 18,
              backgroundColor: 'white'
            },
            b: {
              color: '#8c8c8c',
              fontSize: 18,
              backgroundColor: 'white'
            },
            c: {
              color: '#999',
              fontSize: 14,
              backgroundColor: 'white'
            }
          }
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 16,
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        data: chartData.value
      }
    ]
  }
  myChart.clear()
  myChart.setOption(option, true)
}


const tableData = ref([{no: '0'}, {no: '1'}, {no: '2'}]);
// 批量选中的值
const selection = ref([])
const handleSelectionChange = (val) => {
  selection.value = val;
}
// 批量续费
const checkoutAll = () => {
  if (selection.value.length === 0) {
    ElMessage.error(i18n.global.t('common.please.select'))
    return
  }

  console.log(selection.value)
}

// 分页
const current = ref(1);
const size = ref(10);
const totals = ref(10)
const handleCurrentChange = async (page) => {
  current.value = page;
};

/**
 * 文件存储的空间大小
 */
const spaceSize = computed(() => store.state.cloud.spaceSize)

// 显示存储空间明细对话框
const showStationDetails = () => {
  dialogVisibleDetails.value = true
}

const syncStorageData = async (searchType = route.query.searchType) => {
  isSyncingChartData.value = true

  try {
    if (!searchType || isNormalUser.value) {
      // 企业子账户
      await store.dispatch("cloud/queryByEnterprisesApis", {type: 1})
    } else {
      // 个人账户
      const payload = {type: 1}
      if (searchType) {
        payload.searchType = searchType * 1
      } else {
        if (isNormalUser.value) {
          payload.searchType = 2
        } else if (isEnterpriseChildUser.value) {
          payload.searchType = 1
        }
      }
      await store.dispatch("cloud/getPersonAndCompanyInfoDataDetailApis", payload)
      await store.dispatch("cloud/queryByUserIdApis")
    }
  } finally {
    isSyncingChartData.value = false
  }

  await nextTick()
  renderEcharts()
}

onMounted(async () => {
  await syncStorageData()
})

// 监听数据变化，重新渲染图表（只监听实际使用的数据源）
watch(
  chartData,
  async () => {
    if (isSyncingChartData.value) {
      return
    }

    await nextTick()
    renderEcharts()
  },
  { deep: true }
)

// 监听 searchType 变化
watch(
  () => route.query.searchType,
  async (newVal, oldVal) => {
    if (newVal !== oldVal) {
      await syncStorageData(newVal)
    }
  }
)

watch(
  lang,
  async () => {
    await nextTick()
    renderEcharts()
  }
)

onUnmounted(() => {
  try {
    myChartTargetDom.value?.dispose()
  } catch (e) {

  }
})

const langClass = computed(() => {
  return lang.value !== 'zh-CN' ? 'lang-en' : 'lang-zh'
})
</script>

<style lang="less" scoped>

.inners {
  width: 100% !important;
  min-width: 100% !important;
  position: relative;
}

.right {
  height: max-content !important;
  padding-bottom: 70px !important;
}

.inner_box {
  display: flex;
  flex-direction: column;
  //justify-content: space-between;
  //align-items: flex-start;

  .left_box {
    width: auto;
    min-width: 450px;

    div {
      margin-bottom: 10px;
    }
  }

  .right_box {
    width: calc(100% - 320px);
    flex: 1 1;
  }
}

.line_title {
  font-family: PingFangSC, PingFang SC;
  display: inline-block;
  width: max-content;
  min-width: 80px;
  color: #999;
  font-size: 14px;
}

.line_title.lang-zh {
  min-width: 80px;
}

.line_title.lang-en {
  text-align: right;
  min-width: 120px;
}

.txt {
  display: inline-block;
  color: #333;
  font-size: 14px;
  margin-left: 10px;
}

.results {
  width: 100%;
  border-top: 1px solid #e8e8e8;
  height: 53px;
  bottom: 0px;
  left: 0px;
  position: absolute;
  display: flex;
  justify-content: space-between;

  .buttons_pays {
    padding: 0 35px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    background: #d93737;
    margin-left: auto;
    cursor: pointer;
  }
}

.content_text {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  margin-left: 10px;
}

.storage-details {
  padding: 10px 0;

  :deep(.el-table) {
    font-size: 13px;
  }

  :deep(.el-table .cell) {
    font-size: 13px !important;
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
</style>
